module.exports = __webpack_public_path__ + "optin-header.163048aa45769f97f88f.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/images/headers/optin-header.jpg
// module id = ../../../../../src/assets/images/headers/optin-header.jpg
// module chunks = styles